import Vue from 'vue';

const store = {
    namespaced: true,
    state() {
        return {
            cart: {
                products: [],
                deliveryPrice: null,
                discount: 0,
                selectedDeliveryType: 'standart',
                deliveryTypes: ['standart', 'express'],
                deliveryMethod: 'address',
                orderNumber: null,
                paymentUrl: null,
                trans_id: null,
                storeId: null,
                deliveryDateAndTime: null,
            },
            promoCode: null,
            isFetchingPromoCode: false,
            deliveryText: '',
            toggle: {
                isOpenCart: false,
                isAnimateIn: false,
                isAnimateOut: false,
                isShowTooltip: false,
                isShowAddedToCartNotification: false,
                isCheckoutAnimatedIn: false,
                isCheckoutAnimatedOut: false,
            },
            showCheckoutModal: false,
            showCheckoutModalSuccess: false,
            showOneClickModalSuccess: false,
            showPreorderModalSuccess: false,
            firstToKnowModalSuccess: false,
            showPaymentModalSuccess: false,
            addresses: {
                regions: [
                    {
                        regionId: 3,
                        label: 'kishinev',
                        localities: [
                            {
                                localityId: 'kishinev',
                                label: 'kishinev',
                            },
                            {
                                localityId: 'bubueci',
                                label: 'bubueci',
                            },
                            {
                                localityId: 'budsheti',
                                label: 'budsheti',
                            },
                            {
                                localityId: 'vatra',
                                label: 'vatra',
                            },
                            {
                                localityId: 'gidighici',
                                label: 'gidighici',
                            },
                            {
                                localityId: 'dumbrava',
                                label: 'dumbrava',
                            },
                            {
                                localityId: 'codru',
                                label: 'codru',
                            },
                            {
                                localityId: 'colonitsa',
                                label: 'colonitsa',
                            },
                            {
                                localityId: 'krikovo',
                                label: 'krikovo',
                            },
                            {
                                localityId: 'stavceni',
                                label: 'stavceni',
                            },
                            {
                                localityId: 'sinjera',
                                label: 'sinjera',
                            },
                            {
                                localityId: 'cioresku',
                                label: 'cioresku',
                            },
                        ],
                    },
                    {
                        regionId: 'balti',
                        label: 'balti',
                        localities: [
                            {
                                localityId: 'balti',
                                label: 'balti',
                            },
                        ],
                    },
                    // {
                    //   regionId: 'tiraspoli',
                    //   label: 'tiraspoli',
                    //   localities: [
                    //     {
                    //       localityId: 'tiraspoli',
                    //       label: 'tiraspoli'
                    //     }
                    //   ]
                    // },
                    {
                        regionId: 'cahul',
                        label: 'cahul',
                        localities: [
                            {
                                localityId: 'cahul',
                                label: 'cahul',
                            },
                        ],
                    },
                    // {
                    //   regionId: 'benderi',
                    //   label: 'benderi',
                    //   localities: [
                    //     {
                    //       localityId: 'benderi',
                    //       label: 'benderi'
                    //     }
                    //   ]
                    // },
                    {
                        regionId: 'briceni',
                        label: 'briceni',
                        localities: [
                            {
                                localityId: 'briceni',
                                label: 'briceni',
                            },
                        ],
                    },
                    {
                        regionId: 'drochia',
                        label: 'drochia',
                        localities: [
                            {
                                localityId: 'drochia',
                                label: 'drochia',
                            },
                        ],
                    },
                    {
                        regionId: 'edinet',
                        label: 'edinet',
                        localities: [
                            {
                                localityId: 'edinet',
                                label: 'edinet',
                            },
                        ],
                    },
                    {
                        regionId: 'cantemir',
                        label: 'cantemir',
                        localities: [
                            {
                                localityId: 'cantemir',
                                label: 'cantemir',
                            },
                        ],
                    },
                    {
                        regionId: 'comrat',
                        label: 'comrat',
                        localities: [
                            {
                                localityId: 'comrat',
                                label: 'comrat',
                            },
                        ],
                    },
                    {
                        regionId: 'novieaneni',
                        label: 'novieaneni',
                        localities: [
                            {
                                localityId: 'novieaneni',
                                label: 'novieaneni',
                            },
                            {
                                localityId: 'noviemereni',
                                label: 'noviemereni',
                            },
                            {
                                localityId: 'floreni',
                                label: 'floreni',
                            },
                        ],
                    },
                    {
                        regionId: 'orhei',
                        label: 'orhei',
                        localities: [
                            {
                                localityId: 'orhei',
                                label: 'orhei',
                            },
                        ],
                    },
                    {
                        regionId: 'rezina',
                        label: 'rezina',
                        localities: [
                            {
                                localityId: 'rezina',
                                label: 'rezina',
                            },
                        ],
                    },
                    {
                        regionId: 'soroka',
                        label: 'soroka',
                        localities: [
                            {
                                localityId: 'soroka',
                                label: 'soroka',
                            },
                        ],
                    },
                    {
                        regionId: 'straseni',
                        label: 'straseni',
                        localities: [
                            {
                                localityId: 'straseni',
                                label: 'straseni',
                            },
                        ],
                    },
                    {
                        regionId: 'ungheni',
                        label: 'ungheni',
                        localities: [
                            {
                                localityId: 'ungheni',
                                label: 'ungheni',
                            },
                        ],
                    },
                    {
                        regionId: 'floresti',
                        label: 'floresti',
                        localities: [
                            {
                                localityId: 'floresti',
                                label: 'floresti',
                            },
                        ],
                    },
                    {
                        regionId: 'chadirLunga',
                        label: 'chadirLunga',
                        localities: [
                            {
                                localityId: 'chadirLunga',
                                label: 'chadirLunga',
                            },
                        ],
                    },
                    {
                        regionId: 'ialoveni',
                        label: 'ialoveni',
                        localities: [
                            {
                                localityId: 'ialoveni',
                                label: 'ialoveni',
                            },
                        ],
                    },
                ],
                selectedRegionId: 3,
                selectedLocalityId: 'kishinev',
            },
        };
    },
    getters: {
        getIsOpenCart(state) {
            return state.toggle.isOpenCart || state.showCheckoutModal || state.showCheckoutModalSuccess;
        },
        getCart(state) {
            return state.cart;
        },
        deliveryText(state) {
            return state.deliveryText;
        },
        getProducts(state) {
            return state.cart.products;
        },
        getProductsLength(state) {
            let totalProducts = 0;
            state.cart.products.filter(p => {
                totalProducts += p.count;
            });

            return totalProducts;
        },
        getTotalPrice(state) {
            let newTotalPrice = 0;

            if (state.cart.products.length) {
                newTotalPrice = state.cart.products.reduce((accumulator, current) => {
                    return accumulator + current.product.price * current.count;
                }, 0);
            }

            return Number(newTotalPrice.toFixed(2));
        },
        getTotalPriceWidthDiscount(state) {
            return state.promoCode?.general_price ? Number(Number(state.promoCode.general_price).toFixed(2)) : 0;
        },
        getTotalLoyaltiesGivePoints(state) {
            if (state.cart.products.length) {
                return state.cart.products.reduce((accumulator, current) => {
                    if (current.product.loyalty_checked) {
                        return accumulator;
                    }
                    return accumulator + Number(current.product.loyalty_give) * current.count;
                }, 0);
            }
            return 0;
        },
        getDeliveryPrice(state, getters, rootState, rootGetters) {
            let deliveryPrice = rootGetters['global/getDeliveryPrice'];

            if (!deliveryPrice.length) return 0;

            let totalPrice = rootGetters['cart/getTotalPrice'];
            const globalSettings = rootGetters['global/globalSettings'];
            const freeDeliveryPrice = globalSettings?.delivery_price[0]?.free_delivery || null;
            const conditionFreeDeivery = freeDeliveryPrice && totalPrice >= freeDeliveryPrice;

            //get max delivery price
            if (state.cart.deliveryMethod === 'pickup' || conditionFreeDeivery) {
                return 0;
            }

            if (state.cart.products.length) {
                let result = deliveryPrice.map(price => {
                    return getters.getSelectedRegionId === 3
                        ? price[getters.getSelectedDeliveryType + 'Kishinev']
                        : price.regionPrice;
                });
                // let deliveryPrices = state.cart.products.map(product => {
                //     if (product.product.deliveryInfo) {
                //         return getters.getSelectedRegionId === 'kishinev'
                //             ? product.product.deliveryInfo[getters.getSelectedDeliveryType + 'Kishinev']
                //             : product.product.deliveryInfo.regionPrice;
                //     } else {
                //         return 0;
                //     }
                // });
                return Math.max.apply(null, result);
            }
            return 0;
        },
        getDeliveryMethod(state) {
            return state.cart.deliveryMethod;
        },
        getCartFinalPrice(state, getters) {
            let handledDeliveryPrice = getters.getDeliveryPrice;
            const cartDeliveryPrice = state.cart.deliveryPrice;
            const totalPrice = getters.getTotalPriceWidthDiscount ? getters.getTotalPriceWidthDiscount : getters.getTotalPrice;

            if (cartDeliveryPrice !== null) handledDeliveryPrice = state.cart.deliveryPrice;

            return Number(totalPrice) + handledDeliveryPrice - state.cart.discount;
        },
        getToggleCart(state) {
            return state.toggle;
        },
        getShowCheckoutModal(state) {
            return state.showCheckoutModal;
        },
        getShowCheckoutModalSuccess(state) {
            return state.showCheckoutModalSuccess;
        },
        getShowFirstToKnowModalSuccess(state) {
            return state.firstToKnowModalSuccess;
        },
        getShowPreorderModalSuccess(state) {
            return state.showPreorderModalSuccess;
        },
        getShowOneClickModalSuccess(state) {
            return state.showOneClickModalSuccess;
        },
        getShowPaymentModalSuccess(state) {
            return state.showPaymentModalSuccess;
        },
        getRegions(state) {
            return state.addresses.regions;
        },
        getSelectedRegionId(state) {
            return state.addresses.selectedRegionId;
        },
        getSelectedLocalityId(state) {
            return state.addresses.selectedLocalityId;
        },
        getDeliveryTypes(state) {
            return state.cart.deliveryTypes;
        },
        getSelectedDeliveryType(state) {
            return state.cart.selectedDeliveryType;
        },
        getOrderNumber(state) {
            return state.cart.orderNumber;
        },
        getStoreId(state) {
            return state.cart.storeId;
        },
        getDeliveryDateAndTime(state) {
            return state.cart.deliveryDateAndTime;
        },
        getPromoCode(state) {
            return state.promoCode;
        },
        getIsFetchingPromoCode(state) {
            return state.cart.isFetchingPromoCode;
        },
    },
    mutations: {
        setProducts(state, value) {
            state.cart.products = value;
        },
        setCountItemsForProduct: function (state, { productId, count }) {
            this.commit('cart/SET_PROMO_CODE', null);
            if (count >= 0) {
                let newProduct = state.cart.products.find(e => e.product.productId === productId);
                newProduct.count = count;
            }
            if (count === 0) {
                this.commit('cart/removeProductFromCart', productId);
            }
        },
        setUncheckedAllProductValues(state) {
            state.cart.products.forEach(product => {
                product.product.prescription_checked = false;
                product.product.loyalty_checked = false;
            });
        },
        setPrescription(state, { productId, prescription }) {
            let newProduct = state.cart.products.find(e => e.product.productId === productId);
            newProduct.product.prescription_checked = prescription;
        },
        setLoyalty(state, { productId, loyalty }) {
            let newProduct = state.cart.products.find(e => e.product.productId === productId);
            newProduct.product.loyalty_checked = loyalty;
        },
        removeProductFromCart(state, productId) {
            let newProductsList = state.cart.products.filter(e => e.product.productId !== productId);
            Vue.set(state.cart, 'products', newProductsList);
        },
        setIsOpenCart(state, value) {
            state.toggle.isOpenCart = value;
        },
        setIsAnimateOut(state, value) {
            state.toggle.isAnimateOut = value;
        },
        setIsAnimateIn(state, value) {
            state.toggle.isAnimateIn = value;
        },
        setIsCheckoutAnimateOut(state, value) {
            state.toggle.isCheckoutAnimatedOut = value;
        },
        setIsCheckoutAnimateIn(state, value) {
            state.toggle.isCheckoutAnimatedIn = value;
        },
        setIsShowTooltip(state, value) {
            state.toggle.isShowTooltip = value;
        },
        SET_IS_SHOW_ADDED_TO_CART_NOTIFICATION(state, value) {
            state.toggle.isShowAddedToCartNotification = value;
        },
        setAddProductToCart(state, product) {
            let existingProduct = state.cart.products.find(e => e.product.productId === product.productId);
            if (existingProduct) {
                existingProduct.count += product.multiplicity;
            } else {
                state.cart.products.push({ product, count: product.multiplicity });
            }
        },
        setShowCheckoutModal(state, value) {
            state.showCheckoutModal = value;
        },
        setShowCheckoutModalSuccess(state, value) {
            state.showCheckoutModalSuccess = value;
        },
        setShowFirstToKnowModalSuccess(state, value) {
            state.firstToKnowModalSuccess = value;
        },
        setShowPreorderModalSuccess(state, value) {
            state.showPreorderModalSuccess = value;
        },
        setShowOneClickModalSuccess(state, value) {
            state.showOneClickModalSuccess = value;
        },
        setShowPaymentModalSuccess(state, value) {
            state.showPaymentModalSuccess = value;
        },
        setSelectedRegionId(state, value) {
            state.addresses.selectedRegionId = value;
            if (value !== 3) {
                state.cart.selectedDeliveryType = 'standart';
            }
        },
        setSelectedLocalityId(state, value) {
            state.addresses.selectedLocalityId = value;
        },
        setDeliveryType(state, deliveryType) {
            state.cart.selectedDeliveryType = deliveryType;
        },
        SET_DELIVERY_METHOD(state, value) {
            state.cart.deliveryMethod = value;
        },
        emptyCart(state) {
            Vue.set(state.cart, 'products', []);
        },
        initCartStore(state, cart) {
            Vue.set(state.cart, 'products', cart.products || []);
        },
        setOrderNumber(state, value) {
            state.cart.orderNumber = value;
        },
        setPaymentUrl(state, value) {
            state.cart.paymentUrl = value;
        },
        setTransId(state, value) {
            state.cart.trans_id = value;
        },
        SET_DELIVERY_TEXT(state, value) {
            state.deliveryText = value;
        },
        SET_STORE_ID(state, value) {
            state.cart.storeId = value;
        },
        SET_CART_DELIVERY_PRICE(state, value) {
            state.cart.deliveryPrice = value;
        },
        SET_PROMO_CODE(state, value) {
            state.promoCode = value;
        },
        SET_IS_FETCHING_PROMO_CODE(state, value) {
            state.isFetchingPromoCode = value;
        },
    },
    actions: {
        setCount(context, data) {
            context.commit('setCountItemsForProduct', data);
        },
        removeProduct(context, productId) {
            context.commit('removeProductFromCart', productId);
        },
        updateProducts(context, products) {
            context.commit('setProducts', products);
        },
        openCart(context) {
            context.commit('setIsOpenCart', true);
            context.commit('setIsAnimateIn', true);
        },
        openCheckoutCart(context) {
            context.commit('setIsCheckoutAnimateIn', true);
            context.commit('setShowCheckoutModal', true);
        },
        setShowOneClickModalSuccess(context, flag) {
            context.commit('SET_SHOW_ONE_CLICK_MODAL_SUCCESS', flag);
        },
        setCartDeliveryPrice(context, value) {
            context.commit('SET_CART_DELIVERY_PRICE', value);
        },
        setDeliveryMethod(context, value) {
            context.commit('SET_DELIVERY_METHOD', value);
        },
        closeCart(context) {
            context.commit('setIsAnimateOut', true);
            context.commit('setIsAnimateIn', false);
            setTimeout(() => {
                context.commit('setIsAnimateOut', false);
                context.commit('setIsOpenCart', false);
            }, 300);
        },
        closeCheckoutCart(context) {
            context.commit('setIsCheckoutAnimateOut', true);
            context.commit('setIsCheckoutAnimateIn', false);
            setTimeout(() => {
                context.commit('setIsCheckoutAnimateOut', false);
                context.commit('setShowCheckoutModal', false);
            }, 300);
        },
        onShowTooltip(context) {
            context.commit('setIsShowTooltip', true);
            setTimeout(() => {
                context.commit('setIsShowTooltip', false);
            }, 8000);
        },

        async getProductsStockStatus({ commit }, ids) {
            try {
                // Преобразуем массив ids в строку
                const queryString = ids.map(id => `productIds=${id}`).join('&');

                if (queryString.length === 0) return;

                // Отправляем GET-запрос с форматированной строкой параметров
                return await this.$axios.get(`/general/product_checkout_status/?${queryString}`);
            } catch (error) {
                return new Error(error);
            }
        },

        // /general/product_checkout_status/?productIds=12&productIds=17
        addProductToCart({ commit, getters, rootGetters }, product) {
            const globalSettings = rootGetters['global/globalSettings'];

            commit('setAddProductToCart', product);
            if (globalSettings?.mainUiInterface?.product_cart_button_view_type !== 'casadeltabaco') {
                commit('SET_IS_SHOW_ADDED_TO_CART_NOTIFICATION', true);

                setTimeout(() => {
                    commit('SET_IS_SHOW_ADDED_TO_CART_NOTIFICATION', false);
                }, 3000);
            }
        },
        checkoutModalRequest(context) {
            context.commit('setShowCheckoutModal', true);
        },
        getDeliveryText: async function ({ commit }) {
            try {
                const res = await this.$axios({
                    method: 'get',
                    url: `/mi/delivery_info_text`,
                });
                commit('SET_DELIVERY_TEXT', res.data);
            } catch (error) {
                console.dir(error);
            }
        },
        async fetchPromoCode({ commit }, { promoCode, products }) {
            commit('SET_IS_FETCHING_PROMO_CODE', true);
            try {
                const response = await this.$axios.$post('/general/order/preview-promo/', {
                    promo_code: promoCode,
                    products,
                });

                response.promo_code = promoCode;

                commit('SET_PROMO_CODE', response);

                // return response.data;
            } catch (error) {
                console.error(error);
                return error;
            } finally {
                commit('SET_IS_FETCHING_PROMO_CODE', false);
            }
        },
    },
};

export default store;
